import { carBrandsMarquee } from "../data/carBrandsMarquee";
import CarouselBrandSvg from "./brand-glyphs/CarouselBrandSvg";

function BrandGlyph({ icon, initials, svgSrc }) {
  const box =
    "flex h-11 w-11 shrink-0 items-center justify-center lg:h-[3.25rem] lg:w-[3.25rem]";

  if (svgSrc) {
    return (
      <CarouselBrandSvg
        src={svgSrc}
        className={`${box} opacity-65 transition-opacity group-hover:opacity-100`}
      />
    );
  }

  if (icon) {
    return (
      <svg
        viewBox="0 0 24 24"
        aria-hidden
        className={`${box} text-white opacity-65 transition-opacity group-hover:opacity-100`}
      >
        <path fill="currentColor" d={icon.path} />
      </svg>
    );
  }

  return (
    <span
      aria-hidden
      className={`${box} rounded-md bg-white/15 font-[Barlow_Condensed] text-lg font-bold leading-none tracking-tight text-white/90 opacity-80 transition-opacity group-hover:opacity-100 lg:text-xl`}
    >
      {initials}
    </span>
  );
}

export default function Brands({ t }) {
  const list = [...carBrandsMarquee, ...carBrandsMarquee];

  return (
    <section
      id="brands"
      data-testid="brands-section"
      className="bg-[#0b378c] border-b border-[#082a6e] overflow-hidden text-white"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pt-20 lg:pt-24">
        <div className="font-mono text-xs uppercase tracking-[0.3em] text-[#ffb3b4] mb-4">
          {t.brands.eyebrow}
        </div>
        <h2 className="font-[Barlow_Condensed] font-bold uppercase tracking-tight text-white text-4xl sm:text-5xl lg:text-6xl leading-[0.95]">
          {t.brands.title}
        </h2>
      </div>

      <div className="mt-12 lg:mt-16 pb-20 lg:pb-24 relative">
        <div className="absolute left-0 top-0 bottom-0 w-32 bg-gradient-to-r from-[#0b378c] to-transparent z-10 pointer-events-none" />
        <div className="absolute right-0 top-0 bottom-0 w-32 bg-gradient-to-l from-[#0b378c] to-transparent z-10 pointer-events-none" />
        <div
          data-testid="brands-marquee"
          className="flex gap-12 marquee-track whitespace-nowrap"
        >
          {list.map((b, i) => (
            <span
              key={i}
              className="group inline-flex items-center gap-3 font-[Barlow_Condensed] font-bold uppercase text-5xl lg:text-6xl text-white/30 transition-colors tracking-tight hover:text-white"
            >
              <BrandGlyph icon={b.icon} initials={b.initials} svgSrc={b.svgSrc} />
              <span>{b.name}</span>
              <span className="text-[#e3191b] mx-6 select-none">·</span>
            </span>
          ))}
        </div>
      </div>
    </section>
  );
}
